// TODO: Remove this component once mobile support is fully implemented.
import React from 'react';
import MobileNotSupportedPage from './MobileNotSupportedPage';
import { isMobileDevice } from '../utils/deviceDetection';

const ALLOW_MOBILE = import.meta.env.VITE_ALLOW_MOBILE_DEVICES === 'true';

interface MobileBlockProps {
  children: React.ReactNode;
}

const MobileBlock: React.FC<MobileBlockProps> = ({ children }) => {
  if (!ALLOW_MOBILE && isMobileDevice()) {
    return <MobileNotSupportedPage />;
  }
  return <>{children}</>;
};

export default MobileBlock;
